<template>
  <div>
    <comHeaderAnyone :propScreenTitle="screenTitle"></comHeaderAnyone>
    <v-main>
      <v-container id="container" fluid>
        <v-card>
          <v-tabs show-arrows v-model="tabNo" active-class="blue lighten-4">
            <v-tab class="tab-title">利用規約</v-tab>
            <v-tab class="tab-title">個人情報取り扱いについて</v-tab>
            <v-tab class="tab-title">特定商取引法に基づく表記</v-tab>
            <v-tab class="tab-title">運営法人</v-tab>

            <v-tab-item>
              <v-card flat>
                <v-card-text class="tab-text">
                  <span v-html="getTermService"></span>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="tab-text">
                  <span v-html="getPrivacyPolicy"></span>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="tab-text">
                  <span v-html="getComTranLaw"></span>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-text class="tab-text">
                  <span v-html="getAboutUs"></span>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
        <!-- ボタンエリア -->
        <br/>
        <v-row>
          <v-col cols="12" class="d-flex align-center justify-center">
            <v-btn x-large color="warning" dark min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ServicePolicy",
  props: ["kbnTyp", "KbnCd"],
  computed:  {
    ...mapGetters('terms', ['getTermService', 'getPrivacyPolicy', 'getComTranLaw', 'getAboutUs', 'getPersonalInfo'])
  },
  data() {
    return {
      screenTitle: "利用規約",
      tabNo: Number(this.KbnCd),
    };
  },

  methods :{
    // CloseWindow() {
    //   window.close();
    //   return false;
    // }
    /*
    * 戻るボタン押下
    */
    back(){
      // 遷移元画面へ戻る
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "PSS100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },
  }
};
</script>

<style scoped>
#container {
  margin-top: 30px;
}

.text-end {
  text-align: right;
  margin-right: 20px;
}

.tab-title {
  justify-content: left;
  }

.tab-text p {
  color: #000000;
}

</style>
